import * as d from 'decoders'
import { storageValue, useStorageValue } from 'src/helpers/storage'

// Store collapsed state as an object: { [menuKey: string]: boolean }
export type CollapsibleMenuState = Record<string, boolean>

export const collapsibleMenuStorage = storageValue<CollapsibleMenuState>(
  'app:sidebarCollapsibleMenus',
  (value) => JSON.stringify(value),
  (serializedValue) => {
    return d.record(d.boolean).verify(JSON.parse(serializedValue))
  }
)

export function useCollapsibleMenu(
  menuKey: string,
  defaultOpen: boolean = false
): [boolean, (isOpen: boolean) => void] {
  const state = useStorageValue(collapsibleMenuStorage)

  const isOpen = state?.[menuKey] ?? defaultOpen

  const setIsOpen = (newIsOpen: boolean): void => {
    const currentState = collapsibleMenuStorage.getValue() ?? {}
    collapsibleMenuStorage.setValue({
      ...currentState,
      [menuKey]: newIsOpen,
    })
  }

  return [isOpen, setIsOpen]
}
